import { render, staticRenderFns } from "./TransactionOrders.vue?vue&type=template&id=52ff334c&scoped=true"
import script from "./TransactionOrders.vue?vue&type=script&lang=js"
export * from "./TransactionOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff334c",
  null
  
)

export default component.exports